import * as yup from 'yup';

import { IClientForm, ICustomParameter } from 'api/clients/types';
import { addressFieldSchema, personNameFieldSchema } from 'utils/form';
import { INullable, TObject } from 'utils/types';

export enum NAVIGATION_OPTIONS {
  ADDITIONAL = 'additional',
  CLIENT_INFO = 'clientInfo',
  CUSTOM_PARAMETERS = 'customParameters',
  GENERAL = 'general',
}

export const NAVIGATION_LIST = [
  { name: NAVIGATION_OPTIONS.GENERAL },
  { name: NAVIGATION_OPTIONS.CLIENT_INFO },
  { name: NAVIGATION_OPTIONS.ADDITIONAL },
  { name: NAVIGATION_OPTIONS.CUSTOM_PARAMETERS },
];

export const nullableCustomParameter: ICustomParameter = {
  key: '',
  value: null,
};

export const defaultValues = {
  addressLine1: null,
  addressLine2: null,
  city: null,
  countryCode: null,
  customParams: null,
  dateOfBirth: null,
  email: null,
  firstName: null,
  gender: null,
  ip: null,
  lastName: null,
  locale: null,
  merchantCustomerId: null,
  merchantTerminalId: null,
  personalId: null,
  phone: null,
  phoneCountryCode: null,
  postalCode: null,
  registrationDate: null,
  registrationIp: null,
  state: null,
  taxNumber: null,
  terminalLinkId: null,
} as IClientForm;

export const validationSchema = yup.object().shape({
  addressLine1: addressFieldSchema,
  addressLine2: addressFieldSchema,
  city: addressFieldSchema,
  firstName: personNameFieldSchema,
  lastName: personNameFieldSchema,
  state: addressFieldSchema,
});

export const normalizeCustomParameters = (
  data: INullable<ICustomParameter[]>,
): INullable<TObject> => {
  const obj =
    data?.reduce((acc, item) => {
      acc[item.key as string] = item.value;
      return acc;
    }, {} as TObject) || {};

  return Object.keys(obj).length ? obj : null;
};

export const mapErrorsToIndices = (
  dataArray: INullable<ICustomParameter[]>,
  errorObject?: Record<string, string[]>,
): Record<string, string[]> => {
  const mappedErrors: Record<string, string[]> = {};
  const errors = errorObject || {};

  const hasGlobalCustomParamsError = Object.prototype.hasOwnProperty.call(
    errors,
    'customParams',
  );

  Object.entries(errors).forEach(([errorPath, messages]) => {
    if (!errorPath.startsWith('customParams')) {
      mappedErrors[errorPath] = messages;
      return;
    }

    if (hasGlobalCustomParamsError) {
      if (errorPath === 'customParams') {
        mappedErrors[errorPath] = messages;
      }
      return;
    }

    const keyName = errorPath.substring(errorPath.indexOf('.') + 1);
    const index = dataArray?.findIndex((item) => item.key === keyName);

    if (index !== undefined && index !== -1) {
      const firstError = messages[0] || '';
      const fieldType = firstError.includes('.key.') ? 'key' : 'value';

      const cleanedMessages = messages.map((msg) => {
        return msg.replace(/\.customParams\.(value|key)\./, '.');
      });

      const newKey = `customParams[${index}].${fieldType}`;
      mappedErrors[newKey] = cleanedMessages;
    } else {
      mappedErrors[errorPath] = messages;
    }
  });

  return mappedErrors;
};
